import React from 'react'
import {
} from './styles';
import { Link } from 'react-router-dom';

import { Container, Content, Footer, Button } from "./styles"; 

export const LandingPage = () => (
    <Container>
        <Content>
            <div className="blank"></div>
            <h1>Fellas</h1>
            <Footer>
                <Button>
                    <Link className="link-login" to="/login">Login</Link>
                </Button>
                <div>
                    Não tem uma conta? <Link className="link-signup" to="/signup">Criar</Link>
                </div>
            </Footer>
        </Content>
    </Container>
);